import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { useGetUserInfo } from "src/api/auth";
import { useGetUserCarriers } from "src/api/carrier";
import { ReactComponent as BuildingIcon } from "src/assets/icons/building.svg";
import { ReactComponent as DisableCarrierIcon } from "src/assets/icons/carrier-disable.svg";
import { ReactComponent as CarrierTruckIcon } from "src/assets/icons/carrier-truck.svg";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus.svg";
import { ReactComponent as TickIcon } from "src/assets/icons/tick.svg";
import Button from "src/components/button";
import ErrorComponent from "src/components/error";
import Layout from "src/components/layout";
import Spinner from "src/components/spinner";
import Typography from "src/components/typography";
import { paths } from "src/pages/paths";
import axiosInstance from "src/utils/axios";

function DisableCarrierPage() {
	const navigate = useNavigate();

	const currentCarrierId = localStorage.getItem("carrierId");

	const {
		data: userCarriersData,
		isLoading: userCarriersLoading,
		error: userCarriersError,
	} = useGetUserCarriers({});

	const queryClient = useQueryClient();

	const { data: userInfoData } = useGetUserInfo({
		enabled: false,
	});

	const anotherCarriers = userCarriersData?.results.filter(
		(item) => item.id !== userInfoData?.data.current_carrier?.id,
	);
	return (
		<Layout transparent backButton={false}>
			<div className="flex justify-center items-center flex-col gap-y-4">
				<DisableCarrierIcon />
				<Typography variant={"bodyXM"} className="text-neutral-500 mt-2">
					Your selected carrier <b>({userInfoData?.data.current_carrier?.name})</b> has been deactivated.
					You will no longer have access to the platform under this carrier's management. If you need to
					reactivate it in the future, please reach out to support.
				</Typography>
			</div>

			{userCarriersLoading ? (
				<Spinner />
			) : userCarriersError ? (
				<ErrorComponent title="Error" description={userCarriersError.message} />
			) : (
				anotherCarriers &&
				anotherCarriers.length > 0 && (
					<>
						<div className="flex items-center space-x-2">
							<BuildingIcon className="stroke-gray-500" />
							<Typography className="text-gray-500 my-4" variant="bodyXM">
								Approved Carriers
							</Typography>
						</div>
						{anotherCarriers.map((item) => (
							<div
								className="flex items-center space-x-4 rounded-lg border border-gray-300 bg-white p-3"
								key={item.id}
							>
								<CarrierTruckIcon className="size-12" />

								<Typography className="flex-1 text-gray-800" variant="h7">
									{item.title}
								</Typography>

								{currentCarrierId && item.id === parseFloat(currentCarrierId) ? (
									<TickIcon className="size-6" />
								) : (
									<Button
										onClick={async () => {
											void queryClient.invalidateQueries({
												queryKey: ["user-info"],
											});
											localStorage.setItem("carrierId", item.id.toString());
											axiosInstance.defaults.headers.common["HTTP-CURRENT-ID"] = item.id.toString();
											await void queryClient.resetQueries({
												queryKey: ["user-info"],
											});
											await void queryClient.resetQueries({
												queryKey: ["trips"],
											});
											navigate(paths.dashboard.root);
										}}
										className="text-primary cursor-pointer"
										variant="outline"
									>
										Activate
									</Button>
								)}
								{/* {deleteUserCarrierLoading ? (
                  <Spinner />
                ) : (
                  currentCarrierId &&
                  item.id !== parseFloat(currentCarrierId) && (
                    <Dialog>
                      <DialogTrigger>
                        <TrashIcon className="size-6" />
                      </DialogTrigger>
                      <DialogContent className="z-50 flex flex-col items-center justify-center space-y-4 rounded-2xl">
                        <div className="bg-primary z-20 mx-auto -mt-12 flex size-20 items-center justify-center rounded-full p-2">
                          <WarningCircleIcon />
                        </div>
                        <Typography
                          className="text-center text-gray-800"
                          variant="h4"
                        >
                          Are you sure you want{' '}
                          <span className="text-destructive-100">
                            to remove{' '}
                          </span>
                          Carrier?
                        </Typography>
                        <Typography
                          className="text-center text-gray-700"
                          variant="bodyLG"
                        >
                          This action cannot be undo.
                        </Typography>

                        <div className="flex items-center justify-evenly">
                          <DialogClose>
                            <Button variant="outline">Cancel</Button>
                          </DialogClose>
                          <DialogClose>
                            <Button
                              onClick={() => {
                                localStorage.setItem(
                                  'carrierId',
                                  currentCarrierId.toString(),
                                );
                                axiosInstance.defaults.headers.common[
                                  'HTTP-CURRENT-ID'
                                ] = currentCarrierId.toString();
                                void queryClient.resetQueries({
                                  queryKey: ['user-info'],
                                });
                                void queryClient.resetQueries({
                                  queryKey: ['trips'],
                                });
                                setTimeout(() => {
                                  deleteUserRequestMutate({
                                    carrierId: item.id,
                                  })
                                    .then(() => {
                                      void queryClient.refetchQueries({
                                        queryKey: ['user-carriers'],
                                      });
                                    })
                                    .catch(e => {
                                      toast.error(
                                        e.response?.data.message || e.message,
                                      );
                                    });
                                }, 1000);
                              }}
                            >
                              Remove
                            </Button>
                          </DialogClose>
                        </div>
                      </DialogContent>
                    </Dialog>
                  )
                )} */}
							</div>
						))}
					</>
				)
			)}
			{userCarriersData && anotherCarriers?.length === 0 && (
				<Button className="mx-auto mt-10 w-fit" onClick={() => navigate(paths.dashboard.createCarrier)}>
					<Typography>Add Another Carrier </Typography>
					<PlusIcon className="ml-2 stroke-white" />
				</Button>
			)}
		</Layout>
	);
}

export default DisableCarrierPage;
